import Button from 'assets/components/button/Button';
import ThemeButtonLink from 'assets/components/button/themes/Theme.Button.Link';
import { getLocales } from 'assets/locales/Locale';
import { convertToArray } from 'assets/utils/data/Data';
import { OrderType } from 'config/Api.Config';

export default function SortButton({
  apiBody,
  orderBy,
  thenBy,
  onSort,
}: {
  apiBody: Api.IDefaultListRequest;
  orderBy: string;
  thenBy?: string | string[];
  onSort(newApiBody: Api.IDefaultListRequest): void;
}) {
  const { lang } = getLocales();
  const isSorted = apiBody.orderBy === orderBy;
  const isAsc = apiBody.orderType === 'asc';

  return (
    <Button
      class={ThemeButtonLink}
      media={isSorted ? (isAsc ? 'fas-caret-up' : 'fas-caret-down') : 'fas-sort'}
      onClick={onSort}
      active={apiBody.orderBy === orderBy}
      data={{
        orderBy: orderBy,
        orderType: isSorted && !isAsc ? OrderType.asc : OrderType.desc,
        thenBy: convertToArray(thenBy) ?? undefined,
        thenType: !thenBy
          ? undefined
          : (convertToArray(thenBy).map(() => (isSorted && !isAsc ? OrderType.asc : OrderType.desc)) ?? undefined),
      }}
      htmlElementProps={{
        title: lang.sort,
      }}
    />
  );
}
